var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.603,
    height: 12,
    viewBox: "0 0 9.603 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14460"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.936 49.666v1.2h-.6v-1.2h-1.8a.6.6 0 0 1-.6-.6v-1.8h-6v3.6h-.6v-3.6a.6.6 0 0 1 .6-.6h6a.6.6 0 0 1 .426.174l2.4 2.4a.6.6 0 0 1 .174.426zm-.6 8.4h-8.4v-.6h-.6v.6a.6.6 0 0 0 .6.6h8.4a.6.6 0 0 0 .6-.6v-.6h-.6z",
    transform: "translate(-163.334 -46.667)",
    style: {
      fill: "#ff2116"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14456"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21012",
    d: "M9.6 6.3v-.8H7.2v4H8V7.9h1.2v-.8H8v-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21013",
    d: "M5.2 9.5H3.6v-4h1.6a1.2 1.2 0 0 1 1.2 1.2v1.6a1.2 1.2 0 0 1-1.2 1.2zm-.8-.8h.8a.4.4 0 0 0 .4-.4V6.7a.4.4 0 0 0-.4-.4h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21014",
    d: "M2 5.5H0v4h.8V8.3H2a.8.8 0 0 0 .8-.8V6.3a.8.8 0 0 0-.8-.8zm-1.2 2V6.3H2v1.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfImage);
export default __webpack_public_path__ + "static/media/PDFImage.2319dc42f44c1edfcd8312d81b5affd2.svg";
export { ForwardRef as ReactComponent };